export const SLIDER_MAX_COUNT = 20;
